define('TescoMobile_Checkout/js/model/error-processor-multi-row',['mage/url', 'Magento_Ui/js/model/messageList', 'mage/translate'], function (url, globalMessageList, $t) {
  'use strict';

  return {
    process: function (response, messageContainer) {
      var errors, mainError;
      messageContainer = messageContainer || globalMessageList;
      if (response.status == 401) {
        window.location.replace(url.build('customer/account/login/'));
      } else {
        try {
          var _response$responseJSO;
          mainError = JSON.parse(response.responseText);
          errors = (response === null || response === void 0 || (_response$responseJSO = response.responseJSON) === null || _response$responseJSO === void 0 ? void 0 : _response$responseJSO.errors) || [];
        } catch (exception) {
          mainError = {
            message: $t('Something went wrong with your request. Please try again later.')
          };
          errors = [];
        }
        messageContainer.addErrorMessage(mainError);
        errors.forEach(function (error) {
          messageContainer.addErrorMessage(error);
        });
      }
    }
  };
});

